<template>
  <!-- .banner = semantic name, universal language used to refer to components. -->
  <!-- .banner = no styles attributed here, styles are applied on a model to model basis. -->
  <!-- .banner-woolf = component name, "model" name spaced. -->
  <!-- "woolf" = female literary author name, comes from our arbitrary theme. -->
  <!-- "woolf" / model = The model represents, the "composition" of the banner. -->
  <!-- (continued) as in, all of the stylistic characteristics of a given banner. -->
  <!-- Why arbitrary? Well, because it's better than "1 2 3" or "a b c" -->
  <!-- And, trying to describe the visual composition details succinctly is not possible. -->
  <!-- Even if we did, what would happen if some of those identified properties changed? It would void our class names. -->
  <!-- So take a "banner" for example, eventually we would have an array of them. -->
  <!-- The arbitrary name for each one, would get mapped or correspond to a visual composition. -->
  <section class="banner banner-woolf">
    <div class="banner__image">
      <img class="banner__image-image" :src="bannerImage" width="1280" height="906" />
      <div class="banner__heading-w">
        <h1 class="banner__heading" v-html="banner[curLang].heading"></h1>
      </div>
    </div>
    <main class="banner__main">
      <div class="banner__container">
        <p class="banner__intro">{{ banner[curLang].intro }}</p>
        <p class="banner__desc">{{ banner[curLang].desc }}</p>
        <p class="banner__credit">{{ banner[curLang].credit }}</p>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      showMenu: false,
      banner: {
        en: {
          tag: '',
          heading: 'Remembrance Day',
          intro: 'Remembrance Day is marked in Canada every year on 11 November. It is a day of national commemoration for the more than 118,000 Canadians who have died in military service.',
          desc: 'This module provides resources to deliver engaging discussions, lessons and ceremonies. It can be used in the classroom, at home, or in the community to commemorate the service and sacrifices of Canada’s military personnel.',
          credit: 'Generously supported by the Royal Canadian Legion Dominion Command and the Friends of the Canadian War Museum.'
          // scrollMessage: ''
        },
        fr: {
          tag: '',
          heading: 'Le jour du Souvenir',
          intro: 'Au Canada, le jour du Souvenir est souligné le 11 novembre, chaque année. Il s’agit d’un jour de commémoration national en l’honneur des plus de 118 000 Canadiens et Canadiennes qui sont morts durant leur service militaire.',
          desc: 'Ce module contient des ressources pour faciliter la tenue de discussions, de leçons et de cérémonies inspirantes. Il peut être utilisé en classe, à la maison ou dans différents contextes dans la communauté afin de souligner l’engagement et les sacrifices du personnel militaire canadien.',
          credit: 'Avec le généreux soutien de la Direction nationale de la Légion royale canadienne et des Amis du Musée canadien de la guerre.'
        }
      }
    };
  },
  computed: {
    bannerImage() {
      return require('@/assets/images/compressed/Art08-20110076-001-1280x906.jpg');
    }
  },
  methods: {
    toggleMenu(event) {
      console.log('toggleMenu (TheBanner.vue) event', event);
      this.showMenu = !this.showMenu;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/components.banner.scss';
</style>